<template>
    <div class="wp-10" v-if="error">
        <div class="placeholder">
            <p class="acenter">
                {{
                    $l10n.__('Une erreur est survenue, veuillez réinitialiser la liste des filtres')
                }}
            </p>
            <CompassButton
                :label="$t.__('common.actions.reset')"
                @click="$store.dispatch(`${listinghash}/resetFilters`)"
            />
        </div>
    </div>
    <div class="steps-container" v-else>
        <pipeline-step
            v-for="step in funnel.steps"
            :key="step.id"
            :step-data="step"
            :listinghash="listinghash"
            :opps="rows[step.id]"
            v-on:opportunity-update="updateStep"
            v-on:opportunity-update-header="updateHeaderStep"
        >
        </pipeline-step>
    </div>
</template>

<script>
import PipelineStep from './PipelineStep.vue';

export default {
    props: {
        listinghash: {
            type: String,
        },
    },
    computed: {
        rows() {
            return this.$store.state[this.listinghash].rows;
        },

        funnel() {
            return this.$store.state[this.listinghash].funnel;
        },
        error() {
            return this.$store.state[this.listinghash].error;
        },
    },
    methods: {
        updateStep(oid, stepid, newRank, prevOpps, payload) {
            // AJAX call to update opportunity rank in database + in store
            window.axios
                .get('/prospection/pipeline/updaterank', {
                    params: {
                        oid: oid,
                        stepid: stepid,
                        newRank: newRank,
                        prevOpps: prevOpps,
                    },
                })
                .then((response) => {
                    this.$store.dispatch(`${this.listinghash}/updateStep`, {
                        rows: payload,
                        stepid: stepid,
                    });
                    if (response.data.processAutomationStepEnter === 'Y') {
                        window.Opportunity.askProcessAutomationStepEnter(oid);
                    }
                    Push.success(
                        this.$l10n.__('Opportunité déplacée dans la nouvelle étape du pipeline.'),
                        this.$l10n.__('Message système'),
                    );
                })
                .catch((error) => {
                    if (error.response && error.response.status && error.response.status == 403) {
                        Push.error(
                            this.$l10n.__(
                                'Vous ne disposez pas des droits nécessaires pour cette action.',
                            ),
                        );
                    } else {
                        // handle error
                        Push.error(
                            this.$l10n.__(
                                "Une erreur s'est produite lors du déplacement de l'opportunité. Veuillez ré-essayer dans quelques minutes.",
                            ),
                            this.$l10n.__('Erreur'),
                        );
                    }
                });
        },
        updateHeaderStep(payload) {
            this.$store.dispatch(`${this.listinghash}/updateHeaderStep`, {
                payload: payload,
            });
        },
    },
    components: {
        PipelineStep,
    },
};
</script>

<style lang="sass" scoped>
.steps-container{
    flex:1;
    display:flex;
    align-items:stretch;
}
</style>
